import { render, staticRenderFns } from "./FaradayRotationViz.vue?vue&type=template&id=578deada&scoped=true"
import script from "./FaradayRotationViz.vue?vue&type=script&lang=js"
export * from "./FaradayRotationViz.vue?vue&type=script&lang=js"
import style0 from "./FaradayRotationViz.vue?vue&type=style&index=0&id=578deada&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578deada",
  null
  
)

export default component.exports